// extracted by mini-css-extract-plugin
export default {"slider":"quiz_slider__X2z-e","module":"quiz_module__q4HBq"};